import { atom } from 'jotai'
import { selectAtom } from 'jotai/utils'
import * as R from 'remeda'

import { type SurveyFilterGroups } from '~/utils'

type OnChange = (
  data:
    | {
        filterGroups: SurveyFilterGroups
        count: number
      }
    | undefined,
) => void
export const propAtom = atom<{
  surveyId: string
  onChange: OnChange
}>({
  surveyId: null as unknown as string,
  onChange: R.doNothing,
})
export const surveyIdAtom = selectAtom(propAtom, R.prop('surveyId'))
export const onChangeAtom = selectAtom(propAtom, R.prop('onChange'))

export const isVisibleEditDialogAtom = atom(false)
